import { render } from "./ModelDocCard.vue?vue&type=template&id=5d918f30&scoped=true"
import script from "./ModelDocCard.vue?vue&type=script&lang=js"
export * from "./ModelDocCard.vue?vue&type=script&lang=js"

import "./ModelDocCard.vue?vue&type=style&index=0&id=5d918f30&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d918f30"]])

export default __exports__